/* MovitaFit product quiz engine (mf-quiz). No dependencies. */
(function () {
  'use strict';
  if (window.__mfQuizInit) return;
  window.__mfQuizInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // ---------- small utils ----------
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function uid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'q' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }
  function device() {
    var w = window.innerWidth || 0;
    return w < 750 ? 'mobile' : (w < 1100 && 'ontouchstart' in window ? 'tablet' : 'desktop');
  }
  function attribution() {
    var p = new URLSearchParams(location.search);
    var cur = { source: p.get('utm_source') || '', medium: p.get('utm_medium') || '', campaign: p.get('utm_campaign') || '' };
    if (!cur.source && p.get('fbclid')) { cur.source = 'facebook'; cur.medium = cur.medium || 'paid'; }
    if (cur.source) { ss('mf_attr', JSON.stringify(cur)); return cur; }
    var saved = ss('mf_attr');
    if (saved) { try { return JSON.parse(saved); } catch (e) {} }
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    if (ref && ref.indexOf(location.hostname) === -1) return { source: ref, medium: 'referral', campaign: '' };
    return { source: 'direct', medium: '', campaign: '' };
  }
  attribution(); // capture UTMs on first load

  var ICONS = {
    back: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 6 9 12 15 18"></polyline></svg>',
    close: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>',
    bulb: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18h6"></path><path d="M10 21h4"></path><path d="M12 3a6 6 0 0 0-4 10.5c.8.8 1.3 1.7 1.5 2.5h5c.2-.8.7-1.7 1.5-2.5A6 6 0 0 0 12 3z"></path></svg>',
    medal: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C2410C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="9" r="6"></circle><path d="M8.5 14 7 22l5-3 5 3-1.5-8"></path></svg>',
    chev: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 6 15 12 9 18"></polyline></svg>'
  };

  // ---------- plan builders (one per quiz) ----------
  var PLANS = {
    ab: function (a, cfg) {
      var base = { low: 10, mid: 15, high: 20 }[a.q4_level] || 10;
      var slope0 = { low: 1, mid: 2, high: 3 }[a.q4_level] || 1;
      var model = a.q4_level === 'high' ? 'Pro' : 'Standard';
      var days = { short: 5, mid: 4, long: 3 }[a.q5_time] || 4;
      var sets = { short: 2, mid: 3, long: 4 }[a.q5_time] || 3;
      var mins = { short: 10, mid: 15, long: 25 }[a.q5_time] || 15;
      var add = [0, 3, 5, 8], slopeAdd = [0, 0, 1, 1];
      var focus = ['Learn the movement', 'Build the habit', 'Add obliques', 'Push your limit'];
      var detail = [
        'Slow, controlled knee drives. Focus on the squeeze, not the speed.',
        a.q2_barrier === 'bored' ? 'Mix in booty and arm moves on the same machine to keep it fresh.' : 'Same time each day. Protect the streak.',
        a.q3_goal === 'strong' ? 'Alternate knee drives side to side for obliques, plus a set of back work.' : 'Alternate knee drives side to side to work your obliques.',
        'Higher setting, more reps. Track every rep on the LCD monitor.'
      ];
      var total = 0;
      var weeks = [0, 1, 2, 3].map(function (i) {
        var reps = base + add[i], slope = Math.min(4, slope0 + slopeAdd[i]);
        total += days * sets * reps;
        return { tag: 'W' + (i + 1), focus: focus[i], detail: detail[i], dose: sets + '×' + reps + ' · level ' + slope, reps: reps, slope: slope };
      });
      total = Math.round(total / 50) * 50;
      var chips = [
        { neck: 'Neck-friendly', back: 'Easy on the lower back', both: 'Neck and back friendly', none: 'Controlled reps' }[a.q1_pain],
        { busy: 'At home, no gym', gym: 'No membership', bored: 'Varied workouts', unsure: 'Step-by-step', space: 'Folds away' }[a.q2_barrier],
        { low: 'Beginner start', mid: 'Intermediate start', high: 'Advanced start' }[a.q4_level]
      ].filter(Boolean);
      var goalLine = {
        flat: 'Keep up the walks too: that’s what shows up around your waist.',
        lines: 'Definition shows as your core gets stronger and body fat comes down.',
        strong: 'The aim: a core that feels solid in everyday moves like lifting and carrying.'
      }[a.q3_goal] || '';
      var totalTxt = total.toLocaleString('en-US');
      return {
        title: days + ' days a week, ' + mins + ' minutes a day',
        eyebrow: 'Your 4-week core plan',
        chips: chips,
        weeks: weeks,
        note: a.q3_goal === 'flat' ? '+ A brisk 20-minute walk on 2 rest days each week. Core work firms the muscle; overall movement is what trims the waistline.' : '',
        milestones: [
          { t: 'First session done', w: 'Day 1' },
          { t: sets + ' sets of ' + weeks[1].reps + ' reps, no stopping', w: 'Week 2' },
          { t: 'Height level ' + weeks[2].slope + ' unlocked', w: 'Week 3' },
          { t: 'About ' + totalTxt + ' reps and a 4-week streak', w: 'Day 28' }
        ],
        outcome: 'Stick with it for 4 weeks and you’ll have a routine you can keep, a harder setting than day one, and about ' + totalTxt + ' reps behind you. ' + goalLine,
        model: model,
        modelWhy: model === 'Pro' ? 'Adds mountain climbers for your level' : 'Built for beginners, 17 lbs, folds away'
      };
    },
    climber: function (a, cfg) {
      var days = { short: 5, mid: 4, long: 3 }[a.q5_time] || 4;
      var mins = { short: 10, mid: 15, long: 25 }[a.q5_time] || 15;
      var lv0 = { low: 1, mid: 3, high: 5 }[a.q4_level] || 1;
      var steady = Math.min(mins, { low: 5, mid: 8, high: 12 }[a.q4_level] || 5);
      var lvAdd = [0, 0, 1, 2];
      var focus = ['Find your rhythm', 'Build the habit', 'Add glute climbs', 'Push your pace'];
      var detail = [
        'Alternate 1 minute of steady climbing with 1 minute of easy stepping.',
        a.q2_barrier === 'bored' ? 'Switch between upright and glute-focused climbs to keep it fresh.' : 'Same time each day. Protect the streak.',
        a.q3_goal === 'legs' ? 'Spend half of each session leaning slightly forward, hips back, to target glutes and thighs.' : 'Add 2-minute blocks leaning slightly forward, hips back, to work your glutes.',
        'Longer steady blocks and one level up. Track your time on the monitor.'
      ];
      var weeks = [0, 1, 2, 3].map(function (i) {
        var lv = Math.min(9, lv0 + lvAdd[i]);
        return { tag: 'W' + (i + 1), focus: focus[i], detail: detail[i], dose: mins + ' min · level ' + lv, level: lv };
      });
      var total = days * mins * 4;
      var chips = [
        { knees: 'Low-impact', sometimes: 'Joint-friendly pace', avoid: 'Low-impact', fine: 'Cardio + strength' }[a.q1_knees],
        { busy: 'At home, no gym', weather: 'Any weather', gym: 'No membership', bored: 'Varied climbs', space: 'Small footprint' }[a.q2_barrier],
        { low: 'Beginner start', mid: 'Intermediate start', high: 'Advanced start' }[a.q4_level]
      ].filter(Boolean);
      var goalLine = {
        weight: 'Pair it with your everyday food habits: that’s what shows up on the scale.',
        legs: 'Your legs and glutes will have worked in every single session.',
        stamina: 'The aim: everyday stairs that feel like less of a climb.',
        active: 'The aim: moving more, most days, without overthinking it.'
      }[a.q3_goal] || '';
      var totalTxt = total.toLocaleString('en-US');
      return {
        title: days + ' days a week, ' + mins + ' minutes a day',
        eyebrow: 'Your 4-week cardio plan',
        chips: chips,
        weeks: weeks,
        note: a.q3_goal === 'weight' ? '+ Pair your climbs with simple everyday food habits. Cardio burns calories; what you eat decides the scale.' : '',
        milestones: [
          { t: 'First climb done', w: 'Day 1' },
          { t: steady + ' minutes of steady climbing, no stopping', w: 'Week 2' },
          { t: 'Resistance level ' + weeks[2].level + ' unlocked', w: 'Week 3' },
          { t: 'About ' + totalTxt + ' minutes climbed and a 4-week streak', w: 'Day 28' }
        ],
        outcome: 'Stick with it for 4 weeks and you’ll have a cardio routine you can keep, a higher level than day one, and about ' + totalTxt + ' minutes of climbing behind you. ' + goalLine,
        model: 'Standard',
        modelWhy: 'Low-impact cardio, 9 resistance levels, 26.5 lbs'
      };
    }
  };

  // ---------- quiz instance ----------
  function Quiz(root) {
    var cfgEl = root.querySelector('script[data-mf-quiz-config]');
    if (!cfgEl) return;
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    this.root = root;
    this.key = this.cfg.quiz;
    this.qs = this.cfg.questions || [];
    this.state = { step: 1, answers: {}, added: false, busy: false, error: '' };
    this.opened = false;
    this.lastFocus = null;
    this.buildSheet();
    this.bindTriggers();
    this.setupNudge();
  }

  Quiz.prototype.quizId = function (fresh) {
    var k = 'mf_quiz_id_' + this.key;
    var id = fresh ? null : ss(k);
    if (!id) { id = uid(); ss(k, id); ss('mf_quiz_started_' + this.key, null); }
    return id;
  };

  Quiz.prototype.send = function (payload) {
    var url = this.cfg.endpoint;
    if (!url) return;
    var body = JSON.stringify(Object.assign({ quiz: this.key, quiz_id: this.quizId() }, payload));
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return;
    } catch (e) {}
    try { fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body }); } catch (e) {}
  };

  Quiz.prototype.buildSheet = function () {
    var n = this.qs.length;
    var el = document.createElement('div');
    el.className = 'mf-q-sheet';
    el.hidden = true;
    el.innerHTML =
      '<div class="mf-q-sheet__backdrop" data-close></div>' +
      '<div class="mf-q-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="mfq-title-' + esc(this.key) + '">' +
        '<div class="mf-q-sheet__handle"><span></span></div>' +
        '<div class="mf-q-sheet__bar">' +
          '<button type="button" class="mf-q-iconbtn" data-back aria-label="Previous question">' + ICONS.back + '</button>' +
          '<span class="mf-q-sheet__label" data-label></span>' +
          '<button type="button" class="mf-q-iconbtn" data-close aria-label="Close">' + ICONS.close + '</button>' +
        '</div>' +
        '<div class="mf-q-progress" style="grid-template-columns:repeat(' + n + ',minmax(0,1fr))">' + new Array(n + 1).join('<span></span>') + '</div>' +
        '<div class="mf-q-sheet__body" data-body></div>' +
      '</div>';
    document.body.appendChild(el);
    this.sheet = el;
    this.body = el.querySelector('[data-body]');
    var self = this;
    el.addEventListener('click', function (e) {
      var t = e.target.closest('[data-close],[data-back],[data-opt],[data-next],[data-atc],[data-retake]');
      if (!t) return;
      if (t.hasAttribute('data-close')) self.close();
      else if (t.hasAttribute('data-back')) self.go(self.state.step - 1);
      else if (t.hasAttribute('data-opt')) self.pick(t.getAttribute('data-q'), t.getAttribute('data-opt'));
      else if (t.hasAttribute('data-next')) self.go(self.state.step + 1);
      else if (t.hasAttribute('data-atc')) self.addToCart();
      else if (t.hasAttribute('data-retake')) self.retake();
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(); }
      if (e.key === 'Tab') self.trapFocus(e);
    });
  };

  Quiz.prototype.trapFocus = function (e) {
    var f = this.sheet.querySelectorAll('button:not([disabled]):not([hidden]), a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Quiz.prototype.bindTriggers = function () {
    var self = this;
    this.root.querySelectorAll('[data-mf-quiz-open]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(b); });
    });
  };

  Quiz.prototype.open = function (trigger) {
    this.lastFocus = trigger || document.activeElement;
    this.opened = true;
    ss('mf_quiz_opened_' + this.key, '1');
    this.hideNudge();
    if (!ss('mf_quiz_started_' + this.key)) {
      ss('mf_quiz_started_' + this.key, '1');
      var a = attribution();
      this.send({ type: 'start', version: this.cfg.version || '1', product: this.cfg.product || '', source: a.source, medium: a.medium, campaign: a.campaign, device: device() });
    }
    this.render();
    this.sheet.hidden = false;
    document.documentElement.classList.add('mf-q-lock');
    var self = this;
    requestAnimationFrame(function () {
      self.sheet.classList.add('is-open');
      var h = self.sheet.querySelector('.mf-q-title');
      (h || self.sheet.querySelector('[data-close]')).focus({ preventScroll: true });
    });
  };

  Quiz.prototype.close = function () {
    var self = this;
    this.sheet.classList.remove('is-open');
    document.documentElement.classList.remove('mf-q-lock');
    setTimeout(function () { self.sheet.hidden = true; }, 300);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
  };

  Quiz.prototype.go = function (step) {
    var n = this.qs.length;
    if (step < 1) step = 1;
    if (step > n + 1) step = n + 1;
    this.state.step = step;
    this.state.error = '';
    this.render();
    this.body.scrollTop = 0;
    var h = this.sheet.querySelector('.mf-q-title');
    if (h) h.focus({ preventScroll: true });
  };

  Quiz.prototype.pick = function (qid, value) {
    var q = this.qs.filter(function (x) { return x.id === qid; })[0];
    if (!q) return;
    this.state.answers[qid] = value;
    this.state.added = false;
    this.send({ type: 'answer', question: qid, value: value });
    var isLast = this.qs.indexOf(q) === this.qs.length - 1;
    this.render();
    if (isLast) {
      var self = this;
      clearTimeout(this.t);
      this.t = setTimeout(function () { self.go(self.qs.length + 1); }, 320);
    } else {
      var ins = this.body.querySelector('.mf-q-insight');
      if (ins && ins.scrollIntoView) ins.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  Quiz.prototype.retake = function () {
    this.state = { step: 1, answers: {}, added: false, busy: false, error: '' };
    this.quizId(true);
    ss('mf_quiz_started_' + this.key, '1');
    var a = attribution();
    this.send({ type: 'start', version: this.cfg.version || '1', product: this.cfg.product || '', source: a.source, medium: a.medium, campaign: a.campaign, device: device() });
    this.go(1);
  };

  Quiz.prototype.render = function () {
    var n = this.qs.length, step = this.state.step, isResult = step > n;
    var bars = this.sheet.querySelectorAll('.mf-q-progress span');
    bars.forEach(function (b, i) {
      b.className = (i + 1 < step || isResult) ? 'is-done' : (i + 1 === step ? 'is-current' : '');
    });
    this.sheet.querySelector('[data-label]').textContent = isResult ? 'Your plan' : 'Question ' + step + ' of ' + n;
    this.sheet.querySelector('[data-back]').hidden = !(step > 1 && !isResult);
    this.body.innerHTML = isResult ? this.renderResult() : this.renderQuestion(this.qs[step - 1], step === n);
  };

  Quiz.prototype.renderQuestion = function (q, isLast) {
    var self = this, chosen = this.state.answers[q.id];
    var opts = q.options.map(function (o) {
      var sel = chosen === o.v;
      var art = o.img ? '<span class="mf-q-art"><img src="' + esc(o.img) + '" alt="" width="66" height="66" loading="lazy"></span>' : '';
      var text = q.layout === 'h'
        ? '<span class="mf-q-opt__text"><span class="mf-q-opt__label">' + esc(o.label) + '</span>' + (o.sub ? '<span class="mf-q-opt__sub">' + esc(o.sub) + '</span>' : '') + '</span>'
        : '<span class="mf-q-opt__label">' + esc(o.label) + '</span>';
      return '<button type="button" class="mf-q-opt' + (sel ? ' is-selected' : '') + '" data-q="' + esc(q.id) + '" data-opt="' + esc(o.v) + '" aria-pressed="' + sel + '">' + art + text + '</button>';
    }).join('');
    var insight = '';
    if (chosen && !isLast && q.insights && q.insights[chosen]) {
      var ins = q.insights[chosen];
      var nextLabel = this.state.step === this.qs.length - 1 ? 'Last question' : 'Next';
      insight = '<div class="mf-q-insight" role="status"><div class="mf-q-insight__head"><span class="mf-q-insight__dot">' + ICONS.bulb + '</span>' + esc(ins[0]) + '</div><p>' + esc(ins[1]) + '</p><button type="button" class="mf-q-btn" data-next>' + nextLabel + '</button></div>';
    }
    return '<div class="mf-q-head"><p class="mf-q-eyebrow">' + esc(q.eyebrow) + '</p><h2 class="mf-q-title" id="mfq-title-' + esc(self.key) + '" tabindex="-1">' + esc(q.title) + '</h2></div>' +
      '<div class="mf-q-opts mf-q-opts--' + esc(q.layout || 'v') + '">' + opts + '</div>' +
      (q.hint ? '<p class="mf-q-hint">' + esc(q.hint) + '</p>' : '') + insight;
  };

  Quiz.prototype.renderResult = function () {
    var cfg = this.cfg, builder = PLANS[this.key];
    if (!builder) return '<p class="mf-q-error">Plan unavailable.</p>';
    var p = builder(this.state.answers, cfg);
    this.plan = p;
    if (!this.resultSent || this.resultSent !== this.quizId()) {
      this.resultSent = this.quizId();
      this.send({ type: 'result', model: p.model });
    }
    var m = (cfg.models || {})[p.model] || {};
    var weeks = p.weeks.map(function (w) {
      return '<div class="mf-q-week"><span class="mf-q-week__tag">' + esc(w.tag) + '</span><div class="mf-q-week__body"><div class="mf-q-week__top"><span class="mf-q-week__focus">' + esc(w.focus) + '</span><span class="mf-q-week__dose">' + esc(w.dose) + '</span></div><span class="mf-q-week__detail">' + esc(w.detail) + '</span></div></div>';
    }).join('');
    var miles = p.milestones.map(function (x) {
      return '<div class="mf-q-mile"><span class="mf-q-mile__badge">' + ICONS.medal + '</span><span><span class="mf-q-mile__t">' + esc(x.t) + '</span><span class="mf-q-mile__w">' + esc(x.w) + '</span></span></div>';
    }).join('');
    var reviews = cfg.reviews || [];
    var proof = '';
    if (reviews.length) {
      var card = function (r, hidden) {
        var media = r.img ? '<img class="mf-q-review__img" src="' + esc(r.img) + '" alt="" loading="lazy" width="150" height="180">' : '<div class="mf-q-review__quote">“' + esc(r.title) + '”</div>';
        return '<figure class="mf-q-review"' + (hidden ? ' aria-hidden="true"' : '') + '>' + media + '<figcaption>' + (r.img ? '<span class="mf-q-review__t">“' + esc(r.title) + '”</span>' : '') + '<span class="mf-q-review__n">' + esc(r.name) + '</span></figcaption></figure>';
      };
      var set = reviews.map(function (r) { return card(r, false); }).join('');
      var dup = reviews.map(function (r) { return card(r, true); }).join('');
      proof = '<div class="mf-q-proof"><div class="mf-q-proof__head"><p class="mf-q-section-title">People already training with it</p>' + (cfg.rating ? '<span class="mf-q-proof__meta">' + esc(cfg.rating) + '</span>' : '') + '</div><div class="mf-q-marquee" role="region" aria-label="Customer reviews"><div class="mf-q-track">' + set + dup + '</div></div></div>';
    }
    var cta = this.state.added
      ? '<button type="button" class="mf-q-btn mf-q-btn--lg mf-q-btn--done" disabled>Added to cart</button><a class="mf-q-btn mf-q-btn--ghost" href="' + esc(ROOT) + 'cart">View cart and check out</a>'
      : '<button type="button" class="mf-q-btn mf-q-btn--lg" data-atc' + (this.state.busy ? ' disabled' : '') + '>' + (this.state.busy ? 'Adding…' : 'Start my plan · Add to cart ' + esc(m.price || '')) + '</button>';
    return '<div class="mf-q-head"><p class="mf-q-eyebrow">' + esc(p.eyebrow) + '</p><h2 class="mf-q-title" id="mfq-title-' + esc(this.key) + '" tabindex="-1">' + esc(p.title) + '</h2>' +
      '<div class="mf-q-chips">' + p.chips.map(function (c) { return '<span class="mf-q-chip">' + esc(c) + '</span>'; }).join('') + '</div></div>' +
      '<div class="mf-q-weeks">' + weeks + (p.note ? '<p class="mf-q-note">' + esc(p.note) + '</p>' : '') + '</div>' +
      '<div class="mf-q-miles"><p class="mf-q-section-title">What you’ll unlock</p>' + miles + '<p class="mf-q-outcome">' + esc(p.outcome) + '</p></div>' +
      proof +
      '<div class="mf-q-rec">' + (m.img ? '<img class="mf-q-rec__img" src="' + esc(m.img) + '" alt="" width="60" height="60">' : '<span class="mf-q-rec__img"></span>') +
        '<div class="mf-q-rec__body"><span class="mf-q-rec__eyebrow">RECOMMENDED FOR YOUR PLAN</span><span class="mf-q-rec__name">' + esc(cfg.productTitle || '') + (Object.keys(cfg.models || {}).length > 1 ? ' · ' + esc(p.model) : '') + '</span><span class="mf-q-rec__why">' + esc(p.modelWhy) + '</span></div>' +
        '<div class="mf-q-rec__price">' + (m.compare ? '<s>' + esc(m.compare) + '</s>' : '') + '<b>' + esc(m.price || '') + '</b></div></div>' +
      '<div class="mf-q-actions">' + cta + (this.state.error ? '<p class="mf-q-error" role="alert">' + esc(this.state.error) + '</p>' : '') +
        '<button type="button" class="mf-q-btn mf-q-btn--link" data-retake>Retake the quiz</button></div>';
  };

  Quiz.prototype.addToCart = function () {
    var self = this, p = this.plan, m = p && (this.cfg.models || {})[p.model];
    if (!m || !m.variant || this.state.busy) return;
    this.state.busy = true; this.state.error = ''; this.render();
    var attrs = {}; attrs['_mf_quiz_' + this.key] = this.quizId();
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(m.variant), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    }).then(function () {
      self.state.busy = false; self.state.added = true;
      self.send({ type: 'add_to_cart' });
      self.render();
      document.dispatchEvent(new CustomEvent('mf-quiz:added', { detail: { quiz: self.key, variant: m.variant } }));
    }).catch(function (err) {
      self.state.busy = false;
      self.state.error = (err && err.message) || 'Could not add to cart. Please try again.';
      self.render();
    });
  };

  // ---------- nudge pill ----------
  Quiz.prototype.setupNudge = function () {
    var nudge = this.root.querySelector('[data-mf-quiz-nudge]');
    var entry = this.root.querySelector('.mf-q-entry');
    if (!nudge || !entry) return;
    document.body.appendChild(nudge); // escape any transformed ancestor so position:fixed works
    this.nudge = nudge;
    var self = this, key = this.key;
    var until = Number(ls('mf_quiz_nudge_until_' + key) || 0);
    if (until > Date.now() || ss('mf_quiz_nudged_' + key) || ss('mf_quiz_opened_' + key)) return;
    var timeOk = false, scrolledPast = false;
    setTimeout(function () { timeOk = true; maybe(); }, 15000);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { scrolledPast = !en.isIntersecting && en.boundingClientRect.top < 0; });
        maybe();
      }).observe(entry);
    }
    function maybe() {
      if (!timeOk || !scrolledPast || self.opened || ss('mf_quiz_nudged_' + key)) return;
      ss('mf_quiz_nudged_' + key, '1');
      nudge.style.bottom = (bottomOffset() + 16) + 'px';
      nudge.hidden = false;
      requestAnimationFrame(function () { nudge.classList.add('is-visible'); });
    }
    // keep the pill above any fixed bar at the bottom (e.g. sticky add-to-cart)
    function bottomOffset() {
      var h = window.innerHeight, max = 0;
      [8, Math.round(window.innerWidth / 2), window.innerWidth - 8].forEach(function (x) {
        var el = document.elementFromPoint(x, h - 4);
        while (el && el !== document.body && el !== document.documentElement) {
          if (el === nudge || nudge.contains(el)) break;
          var cs = getComputedStyle(el);
          if (cs.position === 'fixed' || cs.position === 'sticky') {
            var r = el.getBoundingClientRect();
            if (r.bottom >= h - 2 && r.height < h / 3) max = Math.max(max, h - r.top);
            break;
          }
          el = el.parentElement;
        }
      });
      return max;
    }
    var x = nudge.querySelector('[data-mf-quiz-dismiss]');
    if (x) x.addEventListener('click', function () {
      ls('mf_quiz_nudge_until_' + key, String(Date.now() + 7 * 864e5));
      self.hideNudge();
    });
  };
  Quiz.prototype.hideNudge = function () {
    var n = this.nudge;
    if (!n) return;
    n.classList.remove('is-visible');
    setTimeout(function () { n.hidden = true; }, 250);
  };

  function boot() {
    document.querySelectorAll('[data-mf-quiz]').forEach(function (root) {
      if (root.__mfq) return;
      root.__mfq = new Quiz(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
